var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading__container", attrs: { id: "loading_hint" } },
    [
      _c(
        "div",
        { staticClass: "loading__box" },
        [
          _c("v-progress-circular", {
            attrs: {
              indeterminate: "",
              size: "18",
              width: "2",
              color: "#2366f8"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "loading__text" }, [
            _vm._v("\n            " + _vm._s(_vm.text) + "\n        ")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }